<div [class]="getGridClass()">
  @for (opt of options(); track opt.value) {
    <div class="flex items-center gap-2">
      <p-checkbox 
        [name]="opt.value" 
        [value]="opt.value"
        [(ngModel)]="value"
        (ngModelChange)="onCheck($event)">
      </p-checkbox>
      <label class="text-sm text-text-main cursor-pointer">
        @if (opt.icon) {
          <i [class]="'pi ' + opt.icon + ' mr-1'"></i>
        }
        {{ opt.label }}
      </label>
    </div>
  }
</div>
